import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@adsk/alloy-react-checkbox';
import { accessStyle, checkboxStyle } from './helpers/styles';

const AccountAccessFieldOption = ({
  getIsOptionDisabled,
  option,
  selectedAccessLevel,
}) => {
  const isChecked =
    Array.isArray(selectedAccessLevel) &&
    selectedAccessLevel.some((access) => access.value === option.value);
  const isDisabled = getIsOptionDisabled(option.value);

  return (
    <div
      css={accessStyle(isDisabled)}
      data-testid="AccountMemberProfile_account_access_field"
    >
      <Checkbox
        checked={isChecked || isDisabled}
        data-testid={`AccountMemberProfile_account_access_field_${option.value}`}
        disabled={isDisabled}
        style={checkboxStyle}
      />
      {option.label}
    </div>
  );
};

AccountAccessFieldOption.propTypes = {
  getIsOptionDisabled: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
  selectedAccessLevel: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    .isRequired,
};

export default AccountAccessFieldOption;
